var map = {
	"./ar.json": 47112,
	"./bg.json": 72437,
	"./cs.json": 99305,
	"./de.json": 85931,
	"./en.json": 45678,
	"./es.json": 48004,
	"./fr.json": 87162,
	"./he.json": 3889,
	"./it.json": 54490,
	"./ja.json": 6349,
	"./kaa.json": 23050,
	"./pl.json": 78491,
	"./pt.json": 25234,
	"./ru.json": 34044,
	"./sv.json": 10970,
	"./tr.json": 12420,
	"./zh.json": 45299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69898;